import React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { CssBaseline, Drawer, IconButton } from '@material-ui/core';
import MenuCloseIcon from '@material-ui/icons/MenuOpen';
import MenuOpenIcon from '@material-ui/icons/Menu';

import { LogoWrap, Divider } from './styles';
import Modulocker from 'assets/images/modulocker.png';
import ModulockerLogo from 'assets/images/logo.png';
import { SideMenu } from './SideMenu';


const drawerWidth = 214;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: 'none',
    },
    drawer: {
      '& .MuiPaper-root': {
        background: 'var(--backgroundSidebar)',
      },
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: theme.spacing(8),
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(10),
      },
    },
    toolbar: {
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
  }),
);

export default function MiniDrawer() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  const handleDrawer = () => {
    setOpen(!open);
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar} style={{ textAlign: open ? 'right' : 'center' }}>
          <IconButton onClick={handleDrawer} >
            {open ? (
              <MenuCloseIcon style={{ fontSize: '24px', color: 'var(--orange)' }} />
            ) : (
              <MenuOpenIcon style={{ fontSize: '24px', color: 'var(--orange)' }} />
            )}
          </IconButton>
          <LogoWrap>
            {open ? (
              <img src={Modulocker} alt="Modulocker" style={{ width: '100%' }} />
            ) : (
              <img src={ModulockerLogo} alt="Modulocker" style={{ width: '24px' }} />
            )}
          </LogoWrap>
        </div>

        <div style={{ padding: '0 16px' }}>
          <Divider />
          <SideMenu open={open} />
        </div>
      </Drawer>
    </div>
  );
}